<template>
  <v-container fluid style="padding-left: 100px">
    <h1>メールアドレス変更</h1>
      <p style="padding-bottom: 15px;">新しいメールアドレス宛に確認メールを送信します。確認リンクをクリックして、新しいメールアドレスでログインしてください。</p>
      <v-form ref="emailForm" v-model="valid" lazy-validation>
        <v-card elevation="0" tile outlined style="max-width: 900px">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-center">新しいメールアドレス</th>
                <th class="text-center">現在のパスワード</th>
                <th></th>
              </tr>
            </thead>
            <tr>
              <td>
                <v-text-field
                  v-model="newEmail"
                  class="ms-5 me-4"
                  style="min-width: 300px"
                  :rules="[presenceValidation]"
                  required
                />
              </td>
              <td>
                <PasswordInput
                  v-model="password"
                  label='パスワード'
                  style="min-width: 200px"
                  class="mx-3"
                />
              </td>
              <td>
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  @click="updateUserAuth"
                >
                  変更確認メールを送信する
                </v-btn>
              </td>
            </tr>
          </v-simple-table>
        </v-card>
      </v-form>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import formValidationUtils from '@/mixins/form_validation_utils'
import PasswordInput from '@/../src/components/uiParts/inputFields/PasswordInput'

export default {
  components: {PasswordInput},
  mixins: [formValidationUtils],
  data: () => {
    return {
      userAuthQuery: {
        userAuth: {}
      },
      valid: true,
      newEmail: '',
      password: ''
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    })
  },
  mounted: function () {
    axios.get(`/api/master/user_auths/${this.currentUserAuth.id}`).then(
      ({ data }) => {
        this.userAuthQuery.userAuth = deserialize(data.data).attributes
        this.userAuthQuery.userAuth.currentPassword = 'Hoge-0221'
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    validateForm () {
      this.valid = this.$refs.emailForm.validate()
    },
    updateUserAuth () {
      this.validateForm()
      if (!this.valid) {
        return false
      }
      this.userAuthQuery.userAuth.email = this.newEmail
      this.userAuthQuery.userAuth.currentPassword = this.password
      axios
        .patch(
          '/frontend_user_auths/user_auths',
          this.userAuthQuery
        )
        .then(
          ({data}) => {
            const payload = {
              status: 200,
              message: data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
      this.valid = true
    }
  }
}
</script>
